import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f2njjv4jzw: FaireBrandEntity = {
  token: "b_f2njjv4jzw",
  type: "brand",
  name: "Milk Jar Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/f4927c60ee7c7596dd1bc8a1c36bb56019bc34df935d02aec5025f4d279461f9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d5a2f7ce69166bc3c833d1d7b744396f3b0b0a8e9a67a6d3ec060cf9772fff0c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f4927c60ee7c7596dd1bc8a1c36bb56019bc34df935d02aec5025f4d279461f9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d5a2f7ce69166bc3c833d1d7b744396f3b0b0a8e9a67a6d3ec060cf9772fff0c.jpeg",
  location: "Calgary, AB, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 92,
  isTopShop: true,
  isInsider: false,
  description:
    "Welcome to Milk Jar Candle Company! Over the past 9 years, Milk Jar has become a household name in sunny Calgary, Alberta. It is not only known for being a locally manufactured staple in Canadian apothecaries but also for the yearly donations that support initiatives toward inclusion and safe workspaces, raising over $488,000 to date. We hope that by modelling inclusive employment where ⅓ of our staff members have a disability and committing to initiatives that foster a safe space for everyone, such as the Trans Affirming Network, our mission of Creating Inviting Spaces will be spread across the world and inclusive employment will not be an exception, it will be the standard. Our vision and mission are in our community, but our passion is in our product. We are proud to manufacture a variety of high-quality products, such as clean-burning coconut soy candles, reed diffusers, perfume rollers and shower steamers (made in collaboration with our friends at DYP). We offer three fragrance lines to ensure the unique needs of every customer are met. Milk Jar’s Original line features premium phthalate-free fragrance oils, the Essential Oil line features plant-based essential oils that provide aromatherapy benefits and our Elevated Line features a blend of high-grade, skin-safe fragrance and essential oils that produce a more luxurious scent. \n\n**Please note, we do not enter into exclusivity agreements with stockists **",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:50.309Z",
    importedBy: "entity-db-cli",
  },
};
